export enum VehicleClaimEndpoints {
    GET_CLAIMS = "ux-mep-consulta-siniestro-pga/gestion-de-siniestro/v1/siniestros",
}
